export const jobs = [
    {
        name: '设计师',
        value: '0',
    },
    {
        name: '建筑师',
        value: '1',
    },
];
